import { type FormEvent, useState } from 'react';
import { MAX_ROOM_LENGTH } from '@/lib/share';
import { TitleLayout } from './splash/TitleScreen';

function randomRoomId(): string {
  return `room-${Math.random().toString(36).slice(2, 8)}`;
}

export function ShuffleIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      className="h-4 w-4"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M16 3h5v5M4 20 21 3M21 16v5h-5M15 15l6 6M4 4l5 5" />
    </svg>
  );
}

export function ConnectScreen({
  defaultRoom,
  onConnect,
}: {
  defaultRoom: string;
  onConnect: (roomId: string) => void;
}) {
  const [roomId, setRoomId] = useState(defaultRoom);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const trimmed = roomId.trim();
    if (!trimmed) return;
    onConnect(trimmed);
  };

  return (
    <TitleLayout>
      <form
        onSubmit={handleSubmit}
        className="pill title-rise flex w-full max-w-sm items-center gap-1.5 p-1.5 [animation-delay:0.3s]"
      >
        <input
          aria-label="Lobby name"
          className="min-w-0 flex-1 bg-transparent px-3 text-sm text-fg placeholder-fg-subtle outline-none"
          value={roomId}
          onChange={(e) => setRoomId(e.target.value)}
          placeholder="Name a lobby to join or create"
          spellCheck={false}
          autoComplete="off"
          maxLength={MAX_ROOM_LENGTH}
        />
        <button
          type="button"
          onClick={() => setRoomId(randomRoomId())}
          title="Random lobby name"
          aria-label="Random lobby name"
          className="btn btn-ghost btn-icon"
        >
          <ShuffleIcon />
        </button>
        <button type="submit" disabled={!roomId.trim()} className="btn btn-primary">
          Play
        </button>
      </form>
    </TitleLayout>
  );
}
